module.exports = __webpack_public_path__ + "img/mob2.be93c5f5.png";